interface Props {
  firstName?: string | null;
}

export function PortalHeader({ firstName }: Props) {
  return (
    <header className="portal-header">
      <div className="logo">
        <div className="logo-mark" aria-hidden="true">
          AI
        </div>
        <div className="logo-text">
          AICORES<sup>®</sup>
        </div>
      </div>
      {firstName ? (
        <div className="user-greeting">
          Hi, <strong>{firstName}</strong>
        </div>
      ) : null}
    </header>
  );
}
